/* eslint-disable react/no-danger */
import _ from 'lodash';
import PropTypes from 'prop-types';
import constants from '../../../../config/constants';
import { withApplicationContext } from '../../../../utils/ApplicationContext';
import { withDigitalData } from '../../../../utils/DigitalDataContext';
import { withLabels } from '../../../../utils/LabelsContext';
import Tooltip, { TooltipText } from '../../../ui/Tooltip/Tooltip';
import { getTooltipText } from '../../helpers';
import { useSellerInfo } from '../../hooks/useSellerInfo';
import { SellerInfoDesktopStyle } from './style';

const SellerInfoDesktop = ({ product, labels, appCtx, digitalData }) => {
  const sellerInfo = useSellerInfo({ product, appCtx, digitalData });

  if (!sellerInfo.shouldRender) {
    return null;
  }

  const { validatedSellerName, sellerClass, sellerLink, isOutOfStock, isSellerPopupEnabled } = sellerInfo;

  return (
    <div className={`seller-info seller-info--rebranded ${isOutOfStock && 'seller-info--out-of-stock'}`}>
      <div className="seller-info__container fa--seller-info__desktop">
        <span className="seller-info__label">{labels.SELLER_SOLD_BY}&nbsp;</span>
        {sellerClass ? <span className={`seller-info__icon seller-info__icon--${sellerClass}`} /> : null}
        <a id="testId-SellerInfo-sellerName" href={sellerLink} className="seller-info__link">
          <span className="seller-info__seller-name">{validatedSellerName}</span>
        </a>

        {isSellerPopupEnabled && (
          <Tooltip
            position="bottom-middle"
            hasCaret
            tooltipContent={
              <TooltipText
                text={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getTooltipText({
                        sellerName: sellerClass || sellerInfo.sellerNameLower,
                        labels,
                        storePlaceholderText: constants.STORE_PLACEHOLDER,
                        sellerData: product.sellerInfo,
                        isNational: !_.get(product, 'internationalShipping.applicable', false),
                      }),
                    }}
                    id="seller-tooltip-text"
                  />
                }
                viewType="medium"
              />
            }
          >
            <i className="csicon-alert seller-info__alert-icon">
              <span className="sr-only">Seller Info</span>
            </i>
          </Tooltip>
        )}
      </div>
      <style jsx>{SellerInfoDesktopStyle}</style>
    </div>
  );
};

SellerInfoDesktop.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  digitalData: PropTypes.object.isRequired,
};

export { SellerInfoDesktop };
export default withApplicationContext(withLabels(withDigitalData(SellerInfoDesktop)));
